/*
 * @Description: Type your file description
 * @Author: qiangwu
 * @LastEditors: qiangwu
 * @Date: 2020-11-20 14:41:55
 * @LastEditTime: 2020-12-03 09:49:28
 * @FilePath: \ensurance-front\src\store\modules\user.js
 */

import jwtDecode from 'jwt-decode'
import * as auth from '@/utils/auth.js'
import store from 'store'
const state = {
  token: auth.getUser(),
  roles: '',
  refreshToken: auth.getRefreshToken(),
  userInfo: store.get('setUserInfo') || {
    FirstName: window.sessionStorage.getItem('userInfo')
  }
}

const mutations = {
  setRoles(state, payload) {
    state.roles = payload.roles
    auth.setUserRoles(payload.roles)
  },
  // 设置token
  setToken(state, payload) {
    state.token = payload.token
    auth.setUser(payload.token)
  },
  // 清除token
  clearToken(state) {
    state.token = {}
    auth.delUser()
  },

  // 设置refreshToken
  setRefreshToken(state, payload) {
    state.refreshToken = payload.refreshToken
    auth.setRefreshToken(payload.refreshToken)
  },
  // 设置用户信息
  setUserInfo(state, payload) {
    state.userInfo = payload.userInfo
  }
}
const actions = {
  getUserInfo() {
    return new Promise((resolve, reject) => {
      const user = jwtDecode(auth.getUser())
      resolve(user)
    })
  },
  getRoles() {
    return this.state.user.roles
  }
}
export default {
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js